import { createContext } from "react";
const VideoV2Provider = createContext();
export default VideoV2Provider;

